class blognavigation extends HTMLElement {
  constructor() {
    super();
    this.OpenSearchbar();
    const searchbarBlog = this.querySelector('.blog__navbar-search-input');
    this.resultsContainer = document.querySelector('.blog__navbar-search-results');
    let debounceTimer;
    searchbarBlog.addEventListener('input', (e) => {
      this.resultsContainer.innerHTML = `<span class="loader-primary"></span>`;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        this.searchBlog(e.target.value);
      }, 800);
    });
  }
  OpenSearchbar() {
    const SearchIcon = this.querySelector('.blog__navbar-search-icon');
    const SearchBar = this.querySelector('.blog__navbar-search-input');
    SearchIcon.addEventListener('click', (e) => {
      e.stopPropagation();
      if (SearchBar.classList.contains('blog__navbar-search-input--active')) {
        SearchBar.classList.remove('blog__navbar-search-input--active');
      } else {
        SearchBar.classList.add('blog__navbar-search-input--active');
      }
    });
  }
  searchBlog(value) {
    const url = `/search?type=article&q=${value}&view=json`;
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        const results = doc.querySelector('.search-results');
        const containerResults = doc.querySelector('.article__search-endpoint');
        if (results && results.querySelector('.search-results__item')) {
          this.resultsContainer.innerHTML = containerResults.innerHTML;
        } else {
          this.resultsContainer.innerHTML = `<h5 class="blog-search__no-result">No Results Found, Try Search Something Else</h5>`;
        }
      })
      .catch((error) => console.error(error));
  }
}
customElements.define('blog-navigation', blognavigation);
